import React from 'react';
import styles from './OrderManagement.module.css';

interface OrderToolbarProps {
    selectedCount: number;
    totalCount: number;
    actions: React.ReactNode;
}

const OrderToolbar: React.FC<OrderToolbarProps> = ({ selectedCount, totalCount, actions }) => (
    <div className={styles.toolbar}>
        <span className={styles['toolbar-info']}>{selectedCount} of {totalCount} selected</span>
        <div className={styles['toolbar-actions']}>{actions}</div>
    </div>
);

export default OrderToolbar;